import {
  memo,
  ReactElement,
  SyntheticEvent,
  useCallback,
  useEffect
} from 'react';
import { useSelector } from 'react-redux';
import {
  EIconSize,
  ZINDEX_HIGH_5,
  ZINDEX_HIGH_6
} from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { GlobalIcon } from 'components/GlobalIcon';
import { Modal } from 'components/Modal';
import { BetBuilderContent } from 'newcomponents/Shared/sportsbook/BetBuilderModal/components/BetBuilderContent';
import { TBetBuilderModalProps } from 'newcomponents/Shared/sportsbook/BetBuilderModal/types';
import { getIsLoggedIn } from 'store/selectors/user-data';
import './index.less';

if (SpringConfigs.IS_RTL) {
  import('./rtl.less');
}

export const BetBuilderModal = memo(
  ({
    betBuilderModalVisible,
    fixtureId,
    toggleBetBuilderModal,
    gameTitle,
    sportId
  }: TBetBuilderModalProps): ReactElement => {
    const isLoggedIn = useSelector(getIsLoggedIn);

    const closeBetBuilderModal = useCallback(
      (e?: SyntheticEvent) => {
        e && e.stopPropagation();
        toggleBetBuilderModal(false);
      },
      [toggleBetBuilderModal]
    );

    useEffect(() => {
      if (!isLoggedIn) {
        closeBetBuilderModal();
      }
    }, [isLoggedIn, closeBetBuilderModal]);

    return (
      <Modal
        maxWidth={1200}
        width={1200}
        zIndex={ZINDEX_HIGH_5}
        align="center"
        renderInBody
        padding={20}
        wrapperContainerPadding="0"
        centered
        closeIcon={
          <GlobalIcon
            lib="generic"
            name="close"
            theme="default"
            size={EIconSize._16}
            color="var(--v3-text-color)"
          />
        }
        visible={betBuilderModalVisible}
        onCancel={closeBetBuilderModal}
        className="bbModal"
        maskStyle={{ zIndex: ZINDEX_HIGH_6 }}
        style={{
          borderRadius: '12px',
          padding: 0
        }}
        bodyStyle={{
          padding: 0,
          textAlign: 'left'
        }}
        image={false}
      >
        {betBuilderModalVisible && (
          <BetBuilderContent
            fixtureId={fixtureId}
            gameTitle={gameTitle}
            sportId={sportId}
          />
        )}
      </Modal>
    );
  }
);
